import React, { useState } from 'react';
import Translation from '../../../common/translation/translation.component';
import { HistoryLayout } from '../../../common/history/history-layout.component';
import KyberConfigDetailsHistory from './kyberconfig-details-history';

const KyberConfigHistory = () => {
    const [enableSearchBox, setEnableSearchBox] = useState(false);
    const [extractAlertMsg, setExtractAlertMsg] = useState('');

    const onClickExtract = () => {
        if (window.confirm(extractAlertMsg)) {
            // remove this once API implemented
            console.log('Extract Kyber Config history logs');
        }
    };

    return (
        <>
            <Translation
                getOnlyText={true}
                onChangeTranslation={(val) => setExtractAlertMsg(val)}
                translationKey={"export_alert_message"} />

            <HistoryLayout
                selectedIndex={[]}
                extractAction={onClickExtract}
                displaySearchBox={setEnableSearchBox}
                isReadOnly={false}
                isReadAndExtractOnly={false}
                isReadAndWrite={true}
                hideCustomColumn={true}
            >
                <KyberConfigDetailsHistory isColSearchShow={enableSearchBox} />
            </HistoryLayout>
        </>
    );
};

export default KyberConfigHistory;
